export interface Testimonial {
  id: string;
  name: string;
  location: string;
  role: string;
  memberSince: string;
  tier: 'Pro' | 'Elite';
  quote: string;
  propertiesAcquired: number;
  roi: string;
  avatarUrl: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 't001',
    name: 'Michael Chen',
    location: 'San Jose, CA',
    role: 'Full-Time Real Estate Investor',
    memberSince: '2023',
    tier: 'Elite',
    quote: 'This platform completely changed my investment strategy. I\'ve acquired 7 properties in 18 months and my portfolio has grown by over 340%. The early-access alerts give me a genuine edge over competing at public auctions.',
    propertiesAcquired: 7,
    roi: '340%',
    avatarUrl: 'https://public.readdy.ai/ai/img_res/002d33bc008998899686535d6a423292.jpg',
  },
  {
    id: 't002',
    name: 'Sandra Williams',
    location: 'Las Vegas, NV',
    role: 'Property Investor & Realtor',
    memberSince: '2022',
    tier: 'Elite',
    quote: 'The legal templates alone saved me over $15,000 in attorney fees last year. Combined with the exclusive property alerts and expert webinars, Foreclosure Recovery is hands-down the best investment I\'ve made in my business.',
    propertiesAcquired: 12,
    roi: '280%',
    avatarUrl: 'https://readdy.ai/api/search-image?query=professional%20African%20American%20woman%2040s%20confident%20smile%20business%20attire%20portrait%20headshot%20neutral%20background%20clean%20photography%20realtor&width=200&height=200&seq=avatar002&orientation=squarish',
  },
  {
    id: 't003',
    name: 'David Ramirez',
    location: 'Phoenix, AZ',
    role: 'Real Estate Syndicator',
    memberSince: '2023',
    tier: 'Pro',
    quote: 'Within my first 60 days as a member I found a Phoenix commercial property at 58% below market value. The AI analytics accurately projected the ROI. Two of my investor partners have since joined the platform.',
    propertiesAcquired: 4,
    roi: '195%',
    avatarUrl: 'https://readdy.ai/api/search-image?query=professional%20Hispanic%20man%2035s%20business%20professional%20portrait%20headshot%20confident%20smile%20neutral%20background%20clean%20studio%20photography%20investor&width=200&height=200&seq=avatar003&orientation=squarish',
  },
  {
    id: 't004',
    name: 'Jennifer Park',
    location: 'San Diego, CA',
    role: 'Residential Investor',
    memberSince: '2024',
    tier: 'Pro',
    quote: 'As a newer investor, the step-by-step guides and monthly webinars were invaluable. I completed my first successful foreclosure acquisition within 90 days of joining. The community forums are incredibly supportive.',
    propertiesAcquired: 2,
    roi: '130%',
    avatarUrl: 'https://readdy.ai/api/search-image?query=professional%20Korean%20American%20woman%2030s%20friendly%20smile%20casual%20business%20attire%20portrait%20headshot%20white%20background%20photography%20investor&width=200&height=200&seq=avatar004&orientation=squarish',
  },
  {
    id: 't005',
    name: 'Robert Thurston',
    location: 'Reno, NV',
    role: 'Buy & Hold Investor',
    memberSince: '2022',
    tier: 'Elite',
    quote: 'The private investor network connected me with a partner who co-funded a Nevada duplex deal that neither of us could have done alone. That partnership has led to three more joint ventures. Priceless community.',
    propertiesAcquired: 9,
    roi: '310%',
    avatarUrl: 'https://readdy.ai/api/search-image?query=professional%20caucasian%20man%2050s%20distinguished%20gray%20hair%20business%20suit%20portrait%20headshot%20confident%20neutral%20background%20photography%20real%20estate%20investor&width=200&height=200&seq=avatar005&orientation=squarish',
  },
  {
    id: 't006',
    name: 'Angela Torres',
    location: 'Tucson, AZ',
    role: 'Investor & Property Manager',
    memberSince: '2023',
    tier: 'Pro',
    quote: 'The title and lien reports are incredibly detailed — they\'ve helped me avoid two deals that would have been nightmares. When I do move forward, I know exactly what I\'m getting into. The peace of mind is worth every penny.',
    propertiesAcquired: 5,
    roi: '225%',
    avatarUrl: 'https://readdy.ai/api/search-image?query=professional%20Latina%20woman%2045s%20warm%20smile%20business%20professional%20blouse%20portrait%20headshot%20neutral%20background%20photography%20property%20investor&width=200&height=200&seq=avatar006&orientation=squarish',
  },
];
